module.exports = __webpack_public_path__ + "img/vigia.cf48fa1f.jpg";